<div class="notifications-header mt-1">
  <div *ngIf="hoffmanTextFlag" class="d-flex aling-items-center title font-omicron tex-size-low msgHoffman">
    <img class="iconMsgHoffman" src="assets/icons/placeholder.png" alt="location">
    <!-- Disponible solo para venta en  -->
    <p class="mb-0" [innerHTML]="hoffmanText | sanitizeHtml"></p>
  </div>
</div>